import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useFlowPaymentService = () => {
    const { doPost, doGet } = useFetch();
    
    const [fetchingCreatePayment, setFetchingCreatePayment] = useState(false);
    const [fetchingGetPaymentStatus, setFetchingGetPaymentStatus] = useState(false);

    const BASE_PATH = 'brand-registrations/payment';

    const createFlowPayment = (verificationId: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/create-flow-payment`),
            body: { verification_id: verificationId },
            setFetching: setFetchingCreatePayment
        });
    };

    const getPaymentStatus = (verificationId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${verificationId}/status`),
            setFetching: setFetchingGetPaymentStatus
        });
    };

    return {
        fetchingCreatePayment,
        fetchingGetPaymentStatus,
        createFlowPayment,
        getPaymentStatus
    };
};

export default useFlowPaymentService;
